import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgList = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.5 8H14.5M4.5 4H14.5M4.5 12H14.5",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1.5 8H3M1.5 4H3M1.5 12H3",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})]
});
export default SvgList;
